import { render, staticRenderFns } from "./AreicleTagCascader.vue?vue&type=template&id=74111095&scoped=true"
import script from "./AreicleTagCascader.vue?vue&type=script&lang=js"
export * from "./AreicleTagCascader.vue?vue&type=script&lang=js"
import style0 from "./AreicleTagCascader.vue?vue&type=style&index=0&id=74111095&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74111095",
  null
  
)

export default component.exports